module.exports = __webpack_public_path__ + "media/images/store/app_gallery-0c04509c0694dbd68581a07b1dd6d73f.png";